import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';

// Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { processResponse, processItemResponse } from '../../../../../utilities/processResponse';
import './SingleSelectTilesResponse.css';
import { BrowserView, MobileView, isBrowser, isMobile, isTablet, deviceType } from 'react-device-detect';


class SingleSelectTilesResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            radioValue: null,
            isSelect: false,
            responseValue:'',
            acceptComment: null,
            tempVal: '',
            checked:false,
			screenWidth:window.screen.width
        };

		this.labels = {};
        this.tempArr = [];
        this.getAllForMultiUser = [];
        this.reviewPage = this.props.questionItemList || [];
        this.isUpdateResponse = false;
        this.dataGuidId = null;
  }

  componentWillReceiveProps(nextProps) {
	if (this.isUpdateResponse !== true) {
		const { items, configuration, getAllItemResponseForMultiple, ratees, rateeKey, putAllForItemCollection, getResPonsesOnLoad } = nextProps;

		var nodeList = document.getElementsByName(`singleTilesResponse_${items.key}`);
		
		var inputBoxList = document.getElementsByName(`acceptComment_${items.key}`);
		var commentPrompt = document.getElementsByName(`acceptCommentPrompts_${items.key}`);
		
		for (const key in getAllItemResponseForMultiple) {
			this.isUpdateResponse = true;
			items.isHide = false;

			if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
				const elementRes = getAllItemResponseForMultiple[key];

				if (rateeKey !== undefined && key === rateeKey) {
					const { itemResponseSets } = elementRes;

					for (const key in itemResponseSets) {
						if (Object.hasOwnProperty.call(itemResponseSets, key)) {
							const elementItemResponseSets = itemResponseSets[key];
							const tempItemResponseSets = itemResponseSets[key];

							if (elementItemResponseSets.itemKey.toLowerCase() === items.key.toLowerCase()) {
								const itemResponsesForGetAll = elementItemResponseSets.itemResponses;

								for (const key in itemResponsesForGetAll) {
									if (Object.hasOwnProperty.call(itemResponsesForGetAll, key)) {
										const responsesCollection = itemResponsesForGetAll[key];

										var responseValue = elementItemResponseSets.itemResponses.length > 0 ? responsesCollection.response : elementItemResponseSets.demographicResponses.length > 0 ? elementItemResponseSets.demographicResponses[0].response : null;

										if (this.state.isSelect === false) {
											this.setState({
												isSelect:true,
												responseValue:responseValue,
												radioValue:responseValue
											});
										}
									}
								}

								if (tempItemResponseSets.itemResponses.length > 0) {
									for (const key in tempItemResponseSets.itemResponses) {
										if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {
											const temp = tempItemResponseSets.itemResponses[key];
											const itemList = this.reviewPage[items.reviewPageKey];

											for (const key in itemList) {
												if (itemList.hasOwnProperty(key)) {
													const itemRes = itemList[key];
													var itemResponseArr = tempItemResponseSets.itemResponses.length > 0 ? tempItemResponseSets.itemResponses : tempItemResponseSets.demographicResponses.length > 0 ? tempItemResponseSets.demographicResponses: [];

													if (this.state.isSelect === false) {
														for (const key in nodeList) {
															if (nodeList.hasOwnProperty(key)) {
																const element = nodeList[key];
																if (element.value == responseValue) {
																	this.setState({ acceptComment: itemResponseArr[0].openEnd});
																	element.checked = true;
																	if (ratees.length < 2) {
																		this.handleSkipPage(responseValue);
																		this.handleDependencyPageSkipLogic();
																		if (element.checked) {
																			this.handleDependencyRequired(element.checked, items.key, element.value);
																		}
																	}														
																	if (configuration.acceptComment !== null && itemResponseArr[0].openEnd !== null) {
																		inputBoxList[key].classList.add('_acceptCommentShow');
																		if(commentPrompt  !== undefined && commentPrompt.length > 0) {
																			commentPrompt[key].classList.add('_showCommentText');
																}
																}
																}
		
															}
														}
														itemRes.isAnswer = temp.response !== null ? true : false;
														itemRes.isRequired = itemRes.requiredIndicator == 2 ? temp.response !== null ? false:true : false;
														itemRes.itemResponses[tempItemResponseSets.itemKey] = itemResponseArr;

														var itemType = configuration.itemType;
														var responseSet = this.props.itemResponses[tempItemResponseSets.itemKey] = {};
														//this.handleDependencyRequired(itemRes.key,itemRes.hasDepend);
														processItemResponse(tempItemResponseSets.itemKey, responseSet, tempItemResponseSets.itemResponses, itemType, rateeKey, putAllForItemCollection,"onLoad");
														if(ratees.length > 1) {
																getResPonsesOnLoad(items.key, tempItemResponseSets, rateeKey);
															} 
														}
												}
											}
										}
									}
								} else {
									if (items.requiredIndicator == 2) {
										items.isRequired = true;
									} else {
										items.isRequired = false;
									}
								}
							}
						}
					}
				}
			}
		}
	}
}

componentDidMount() {

	const { radioValue } = this.state;
	  if (this.props.ratees.length < 2) {
				this.handleDependencyPageSkipLogic();
          	this.handleSkipPage(radioValue);
		   }
	  window.addEventListener('resize', this.resize);
	  window.onresize = this.resize;

}

	
resize = () => {
  this.setState({screenWidth:window.innerWidth});
}


handleChange = async (event, configuration, rateeKey, index, type, tilesAcceptComment) => {
	try {
		
		const { items, handleItemResponse, singleSelectItemConfiguration, itemTempResponses, itemResponseSets, ratees, putAllForItemCollection, dependencies,flag } = this.props;
		const { responseDescription } = configuration;
		
		const filterData = configuration.filter((scaleData) => configuration[index].response == scaleData.response);
		const scaleResponseValue = filterData.length > 0 ? (items.isReversePolarity ? filterData[0].reversePolarityResponseValue :filterData[0].responseValue ):null;

		var acceptComment = type === "textarea" ? event.target.value : this.state.acceptComment;
		
		await this.setState({
			isSelect:true,
			responseValue:configuration[index].responseValue,
			radioValue:configuration[index].responseValue,
			acceptComment: acceptComment,
		});

		var inputBoxList = document.getElementsByName(`acceptComment_${items.key}`);
		var commentPrompt = document.getElementsByName(`acceptCommentPrompts_${items.key}`);
		var nodeList = document.getElementsByName(`singleTilesResponse_${items.key}`);
		if ((acceptComment === null || acceptComment === "") && parseInt(configuration.acceptComment) === 2  && flag !== "MultiUser") {
			inputBoxList[index].classList.add('_acceptCommentRequired');
			this.handleCheckboxElement(true);
		  } else {
			inputBoxList[index].classList.remove('_acceptCommentRequired');
			this.handleCheckboxElement(false);
		}

		if (flag !== "MultiUser") {
            for (const key in nodeList) {
            if (nodeList.hasOwnProperty(key)) {
                const element = nodeList[key];
                if (element.checked && tilesAcceptComment === 1 && key == index) {
                	inputBoxList[key].classList.remove('_acceptCommentHide');
                	inputBoxList[key].classList.add('_acceptCommentShow');
					inputBoxList[key].focus();
					if( commentPrompt !== undefined  && commentPrompt.length > 0 ) {
						commentPrompt[key].classList.remove('_hideCommentText');
						commentPrompt[key].classList.add('_showCommentText');
					}
                } else {
                	inputBoxList[key].classList.remove('_acceptCommentShow');
                	inputBoxList[key].classList.add('_acceptCommentHide');
					if( commentPrompt !== undefined && commentPrompt.length > 0) {
						commentPrompt[key].classList.add('_hideCommentText');
						commentPrompt[key].classList.remove('_showCommentText');
					}
                }
            }
            }
        }


		/* Manage the question answer response */
		for (const key in this.reviewPage[items.reviewPageKey]) {

			if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
				const itemList = this.reviewPage[items.reviewPageKey];
				var itemKey = itemList[key].key;
				var hasDepend = itemList[key].hasDepend;

				if (itemList[key].key === items.key) {
					itemList[key].isAnswer = configuration[index].response !== "" ? true : false;

					if (itemList[key].requiredIndicator == 2) {
						itemList[key].isRequired = itemList[key].isAnswer == true ? false : true;
					} else {
						itemList[key].isRequired = false
					}

					for (const rKey in ratees) {

						if (ratees.hasOwnProperty(rKey)) {
							const tempRatees = ratees[rKey];

							if (tempRatees.dataCollectionGuid === rateeKey) {
								this.dataGuidId = rateeKey;

								itemList[key].itemResponses[itemKey] = [{
									"itemType"     : singleSelectItemConfiguration.itemType,
									"buttonGroup"  : null,
									"sequence"     : 1,
									"isNa"         : itemList[key].isNA,
									"response"     : configuration[index].response == "" ? null : configuration[index].response,
									"responseValue": configuration[index].response == "" ? null : scaleResponseValue,
									"openEnd"      : this.state.acceptComment,
									"responseDescription":responseDescription,
								}];

								var responseSet = this.props.itemTempResponses[itemKey] = {};
								var itemResponses = itemList[key].itemResponses[itemKey];
								var itemType = singleSelectItemConfiguration.itemType;
								this.handleSkipPage(scaleResponseValue);
								processItemResponse(itemKey, responseSet, itemResponses, itemType, this.dataGuidId, putAllForItemCollection,"onChange");
							}
						}
					}
				} else {
					if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
				}
				this.setState({itemResponses:itemList[key].itemResponses[itemList[key].key]});
			}
		}
		
		handleItemResponse(items.key, itemTempResponses, "itemChange", this.dataGuidId);
		this.handleDependencyRequired(itemKey, hasDepend);
		this.handleDependencyPageSkipLogic();
	} catch (error) {
		console.log("Exception: while responding question answer in single select response:_", error);
	}
}

handleRequired = (event, index) => {
    const { items, configuration } = this.props;
    var inputBoxList = document.getElementsByName(`acceptComment_${items.key}`);

    if ((this.state.acceptComment === null || this.state.acceptComment === "") && parseInt(configuration.acceptComment) === 2) {
      inputBoxList[index].classList.add('_acceptCommentRequired');
      inputBoxList[index].focus();
      this.handleCheckboxElement(true);

    } else {
      inputBoxList[index].classList.remove('_acceptCommentRequired');
      this.handleCheckboxElement(false);
    }
  }

handleCheckboxElement = (flag) => {
    try {
      const { items } = this.props;
      var nodeList = document.getElementsByName(`singleTilesResponse_${items.key}`);

      for (const key in nodeList) {
        if (Object.hasOwnProperty.call(nodeList, key)) {
          const element = nodeList[key];
          // element.disabled = flag;
        }
      }
    } catch (error) {
      console.log("Exceptions: Handled the enabled and disabled radio in required case:_", error.message)
	}
}

handleSkipPage = (tempResponseValue) => {
	try {
		const { dependencies, items } = this.props;
		var responseValue = tempResponseValue;
		var nodeList = document.getElementsByName(`singleTilesResponse_${items.key}`);

		for (const key in dependencies) {
			
			if (Object.hasOwnProperty.call(dependencies, key)) {
				const element = dependencies[key];

				element.filter((dep) => {
					if (dep.dependsOnKey === items.key) {
						
						var skipDiv = document.getElementById("survey-item-block_" + dep.key);
						var skipDivOld = document.getElementsByName("survey-item-block");

						var conditionString = "";
						element.map((item, i) => {
							return conditionString += `( ${item.response} ${item.booleanOperator} ${tempResponseValue} ) ${item.dependsOnConditionalOperator !== null ? item.dependsOnConditionalOperator : ""}`
						});


						var newStr = conditionString.length > 15 ? conditionString.substr(0, conditionString.length - 1) : conditionString;
						var result = newStr.split(') |').join(")");
						var newCondition = result.split('|').join("||");

						if (newCondition !== '' && eval(newCondition)) {
							for (const key in skipDivOld) {
								if (Object.hasOwnProperty.call(skipDivOld, key)) {
									const dataId = skipDivOld[key].getAttribute('data-id');
									if (dataId == dep.key) {
										skipDivOld[key].classList.remove('_Unblock');
										skipDivOld[key].classList.add('_block');
										skipDivOld[key].classList.add(`_block_${items.key}_${responseValue}`);
									}
								}
							}
						} else {
                            for (const key in nodeList) {
                                if (Object.hasOwnProperty.call(nodeList, key)) {
                                    const element = nodeList[key];
                                    var newEl = document.getElementsByClassName(`_block_${items.key}_${element.value}`)[0];
                                    if (!element.checked) {
                                        if (newEl !== undefined) {
                                            newEl.classList.remove('_block');
                                            newEl.classList.remove(`_block_${items.key}_${element.value}`);
                                            newEl.classList.add('_Unblock');
                                        }
                                    }
                                }
                            }
                            if (this.state.isSelect) {
                            } else {
								
                                skipDiv.style.display = "none";
                            }
                        }
					}
				})
			}
		}
	} catch (error) {
		// console.log("Exceptions: while skipping item and page", error.message);
	}
}

handleDependencyPageSkipLogic = () => {
    var timeOut = setTimeout(() => {
        const { items, nextPageKey, dependencies, pageList } = this.props;

        for (const key in dependencies) {
            if (Object.hasOwnProperty.call(dependencies, key)) {
                const element = dependencies[key]

                element.filter((dep) => {
                    if (dep.dependsOnKey === items.key) {

                        pageList.filter((page) => {
							const { items } = page;
							page.checkOnNextButtonClick = false;

							items.filter((itm) => {
								if (itm.hasDepend == true) {
									page.checkOnNextButtonClick = true;
								}
							});
                        })
                    }
                })
            }
        }
        clearTimeout(timeOut)
    }, 0);
}


handleDependencyRequired = (itemKey, hasDepend) => {
	try {
		var test = setTimeout(() => {
		const { pageList, nextPageKey } = this.props;

			var _blockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._block`);
			var _unBlockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._Unblock`);
			const nextButton = document.getElementsByClassName(`_buttonHideClass_${this.props.activePageKey}`)[0];

			for (const key in pageList) {
				if (Object.hasOwnProperty.call(pageList, key)) {
					if (pageList[key].key == nextPageKey) {
						const tempItems = pageList[key].items;

				for (const key in tempItems) {
					if (Object.hasOwnProperty.call(tempItems, key)) {
						const element = tempItems[key];

							for (const depKey in _blockElement) {
								if (Object.hasOwnProperty.call(_blockElement, depKey)) {
									const dataId = _blockElement[depKey].getAttribute('data-id');

									if (element.key === dataId) {
										element.isHide = false;
									}
								}
							}

							for (const bKey in _unBlockElement) {
								if (Object.hasOwnProperty.call(_unBlockElement, bKey)) {
									const dataIdUnblock = _unBlockElement[bKey].getAttribute('data-id');

									if (element.key === dataIdUnblock) {
										element.isHide = true;
									}
								}
							}
						}
					}
				} else {
					if(hasDepend) {
						for( const depKey in this.props.dependencies) {
							this.props.dependencies[depKey].map((dep) => {
								if(itemKey == dep.key){
									this.props.handleDependentItem(itemKey,dep.response,null)
								}
							});
						}


						}
					}
				}
			}

			clearTimeout(test);
		}, 0);

	} catch (error) {

	}
}

calculateStringWidth = (string) => {
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext('2d');
	let textWordWidth = ctx.measureText(string);
	return textWordWidth.width
	
}

  render() {
    const {
      configuration,
      rateeKey,
      items,
	  itemKey,
	  className,
	  selectionPromptPlaceholder,
	  selectionPrompt
    } = this.props;
	if(items.layoutHints != undefined) {
		const array = items.layoutHints.split(',');
		var tilesAlignment = "Horizontal"
		if(array.length > 0) {
			for(let i = 0; i < array.length; i++) {
				if(array[i] == "tilesvertical" || array[i] == "tileshorizontal" ) {
					tilesAlignment = array[i];
				}
			}
		}

	}

	const customClass = tilesAlignment === "tilesvertical" ? '_mobileTiles'  :'_browserTiles';

	

    return (
		<Fragment>
			<div>
			<Row>
					<Col xs={12} key={itemKey} className={[`_LIS_SingleSelect`, this.state.screenWidth < 463 ? '_showScroll' : null]}>
						{configuration.scalePreSection !== null ? (
							<div dangerouslySetInnerHTML={{__html: processResponse(configuration.scalePreSection)}}></div>
						) : null}
					<Col col={10}>
							<ButtonGroup className={`${customClass} _adjButton`} >
								  {configuration && configuration.map((responseConfiguration, i) => {
									return (	
										tilesAlignment !== "tilesvertical" ? this.state.screenWidth > 565 ? 
										<>
											{ i == 0 ? 
												<span className={`_browserTilesDescription _firstDescription ${this.calculateStringWidth(configuration[0].responseDescription) > 150 ?  'descriptionSpaceGreater' : 'descriptionSpaceLesser'}`}>
													{configuration[0].responseDescription}
												</span> : null 
											}
									    <ToggleButton
										key={i}
										type="radio"
										name={`singleTilesResponse_${items.key}`}
										id={`singleTilesResponse_${responseConfiguration.response}_${items.key}`}
										checked={responseConfiguration.response == this.state.radioValue}
										value={responseConfiguration.response}
										onClick={(event) =>this.handleChange(event, configuration, rateeKey,i, 'tiles',responseConfiguration.acceptComment)}
										variant={'outline-primary'}
										className={`_TilesItemTypeBrowser ${className} ${responseConfiguration.response == this.state.radioValue ? '_selectedTiles' : ''}`}
										> 
											{responseConfiguration.response}
										</ToggleButton>
										{ i == configuration.length - 1 ? 
										<span className={`_browserTilesDescription _lastDescription ${this.calculateStringWidth(configuration[configuration.length - 1].responseDescription) > 149 ?  'descriptionSpaceGreater' : 'descriptionSpaceLesser'}`}>
											{configuration[configuration.length - 1].responseDescription}
										</span> : null 
										}
										</> :
										<div>
										<ToggleButton
											key={i}
											type="radio"
											name={`singleTilesResponse_${items.key}`}
											id={`singleTilesResponse_${responseConfiguration.response}_${items.key}`}
											checked={responseConfiguration.response == this.state.radioValue}
											value={responseConfiguration.response}
											onClick={(event) =>this.handleChange(event, configuration, rateeKey,i, 'tiles',responseConfiguration.acceptComment)}
											variant={'outline-primary'}
											className={ `${className} ${this.state.screenWidth > 424 ? "_TilesItemTypeBrowser" : "_TilesItemTypeResponsive"} ${responseConfiguration.response == this.state.radioValue ? '_selectedTiles' : ''}`}
											> 
													{responseConfiguration.response}
												</ToggleButton>
											{ i == 0 && this.state.screenWidth  < 565 ? 
												<span className={"_ResponsiveDescStyle"}>
													{configuration[0].responseDescription}
												</span> : null 
											}
											{ i == configuration.length - 1 && this.state.screenWidth < 565 ? 
												<span className={"_ResponsiveDescStyle"}>
													{configuration[configuration.length - 1].responseDescription}
												</span> : null 
											}
										</div> :
										<>
											<Row>
												<Col xs={2} style={{marginLeft:'8px'}}>
												{ i == 0 ? <span className={`_mobileTilesDescription ${this.calculateStringWidth(configuration[0].responseDescription) > 150 ?  'descriptionSpaceGreater' : 'descriptionSpaceLesser'}`}>{configuration[0].responseDescription}</span> : null }
											</Col>
												</Row>
												<Row>
												<Col xs={2} lg={1}>
									<ToggleButton
										key={i}
										type="radio"
										name={`singleTilesResponse_${items.key}`}
										id={`singleTilesResponse_${responseConfiguration.response}_${items.key}`}
										checked={responseConfiguration.response == this.state.radioValue}
										value={responseConfiguration.response}
										onClick={(event) =>this.handleChange(event, configuration, rateeKey,i, 'tiles',responseConfiguration.acceptComment)}
										variant={'outline-primary'}
										className={ `${className} ${this.state.screenWidth > 424 ? "_TilesItemTypeBrowser" : "_TilesItemTypeResponsive"} ${responseConfiguration.response == this.state.radioValue ? '_selectedTiles' : ''}`}
									> 
										{responseConfiguration.response}
									</ToggleButton>
											</Col>
											<Col  xs={8} lg={9}>
												<textarea autofocus
												className={"_acceptCommentHide _tilesCommentVertical"}
												name={`acceptComment_${items.key}`}
												value={this.state.acceptComment}
												onChange={(event) =>this.handleChange(event,configuration,rateeKey,i,"textarea",configuration[i].acceptComment)}
												onBlur={(event) => this.handleRequired(event, i)}
												maxLength={500}
														// placeholder={responseConfiguration.acceptCommentPrompt !== null ? responseConfiguration.acceptCommentPrompt :  "Please tell us why you rated this way."}
												placeholder={selectionPromptPlaceholder !== null ? selectionPromptPlaceholder :  ""}
												/>
											</Col>
											</Row>	
										<Row>
										<Col xs={2} style={{marginLeft:'8px'}}>
											{ i == configuration.length - 1 ? <span className={`_mobileTilesDescription ${this.calculateStringWidth(configuration[configuration.length - 1].responseDescription) > 150 ?  'descriptionSpaceGreater' : 'descriptionSpaceLesser'}`}>{configuration[configuration.length - 1].responseDescription}</span> : null }
										</Col>
									</Row>
								</>
				)	
							
			  })}
            </ButtonGroup>
						</Col>
					</Col>
				</Row>
				<Row>
					<Row className={`_LIS_SingleSelect`}>
						<Col xs={12}>
						{configuration && configuration.map((responseConfiguration, i) => {
							return( tilesAlignment !== "tilesvertical" ? <>
								<Row style={{marginLeft:'15px'}}>
									<Col>
											{/* <span name={`acceptCommentPrompts_${items.key}`} className={"_hideCommentText"}>{ responseConfiguration.acceptCommentPrompt !== null ? responseConfiguration.acceptCommentPrompt :  "Please tell us why you rated this way."}</span> */}
											<span name={`acceptCommentPrompts_${items.key}`} className={"_hideCommentText _alignText"} >{selectionPrompt !== null ? selectionPrompt :  ""}</span>
									</Col>
								</Row>
								<textarea autofocus
									className={"_acceptCommentHide _tilesComment"}
									name={`acceptComment_${items.key}`}
									value={this.state.acceptComment}
									onChange={(event) =>this.handleChange(event,configuration,rateeKey,i,"textarea",configuration[i].acceptComment)}
									onBlur={(event) => this.handleRequired(event, i)}
									maxLength={500}
									rows="4" 
									cols="100" 
										// placeholder={responseConfiguration.acceptCommentPlaceholder !== null ? responseConfiguration.acceptCommentPlaceholder : "Please enter you message"}
										placeholder={selectionPromptPlaceholder !== null ? selectionPromptPlaceholder : ""}
									/></> : null
								)
						})}
						</Col>
					</Row>
			</Row>
			</div>
      	</Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  answeredQuestionCount: state.survey.answeredQuestionCount,
  getAllItemResponse: state.survey.getAllItemResponse,
  getAllItemResponseForMultiple: state.survey.getAllItemResponseForMultiple,
  assessmentInfosForDataCollection: state.survey.assessmentInfoDataCollectionData,
})

export default connect(mapStateToProps)(SingleSelectTilesResponse);